import Model from "./Model";
import * as moment from 'moment';
import Product from "./Product";
import Order from "./Order";
import Collection from "./Collection";
import Address from "./Address";
import ArrayList from "./ArrayList";
import Comment from "./Comment";
import Payment from "./Payment";
class Delivery extends Model {
  constructor(options) {
    super();
    (this as any).product = d => {
      return new Product(d.data);
    };
    (this as any).order = d => {
      return new Order(d.data);
    };
    (this as any).collection = d => {
      return new Collection(d.data);
    };
    (this as any).delivery_address = (d) => {
      return new Address(d.data);
    };
    (this as any).comment = (d) => {
      return new ArrayList<Comment>(Comment, d.data);
    };
    (this as any).collect_payment = (d) => {
      return new Payment(d.data);
    };
    (this as any).delivery_timing_id = (d) => {
      if (!d) {
        return '';
      }
      return d;
    };
    this.bind(options);
  }
  getLastTry(): moment.Moment {
    let m = moment(this['date']);
    return m;
  }
  getReceivedDateMoment(): moment.Moment {
    let m = moment(this['received_date']);
    return m;
  }
  getExpectedDateMoment(): moment.Moment {
    let m = moment(this['expected_date']);
    return m;
  }
}

export default Delivery;
